export enum TipoOrigemErro {
  BANCO = '1',
  NAO_BANCO = '2'
}
